
import { useContext } from 'react';
import { AppContext } from '../contexts/context';
// Tools
import { updatedDiff } from 'deep-object-diff';

// Log verbose mode
const verbose = false;

// ## JS Functions
export const getTimeString = () => {
  // Zeit als String in der Form "14:55" erstellen
  const nowTime = new Date();
  const hour = nowTime.getHours().toString().padStart(2, '0');
  const minute = nowTime.getMinutes().toString().padStart(2, '0');
  const seconds = nowTime.getSeconds().toString().padStart(2, '0');
  const timeString = `${hour}:${minute}:${seconds}`;
  return timeString;
}

export const getDateTimeString = () => {
  // Zeit als String in der Form "240723-112517" erstellen
  const nowTime = new Date();
  const year = nowTime.getFullYear().toString().slice(2);
  const month1 = nowTime.getMonth() + 1;
  const month = month1.toString().padStart(2, '0');
  const day = nowTime.getDate().toString().padStart(2, '0');
  const hour = nowTime.getHours().toString().padStart(2, '0');
  const minute = nowTime.getMinutes().toString().padStart(2, '0');
  const seconds = nowTime.getSeconds().toString().padStart(2, '0');
  const timeString = `${year}${month}${day}-${hour}${minute}${seconds}`;
  return timeString;
}

// ## React Hooks
export const useCheckImportedData = () => {
  const [ state ] = useContext(AppContext);
  let result = false;

  if ((!Object.keys(state.deviceData.origin.P).length && Object.keys(state.deviceData.data.P).length)
  || (!Object.keys(state.deviceData.origin.PR).length && Object.keys(state.deviceData.data.PR).length)
  || (!Object.keys(state.deviceData.origin.PP).length && Object.keys(state.deviceData.data.PP).length)
  ) {
    result = true;
  }

  return result;
}

export const useCountDataKeys = () => {
  const [ state ] = useContext(AppContext);

  let result = 0;
  var updatedP = {};
  var updatedPR = {};
  var updatedPP = {};

  if (useCheckImportedData()) {
    if (Object.keys(state.deviceData.data.P).length) {
      result += Object.keys(state.deviceData.data.P.P).length;
    }
    if (Object.keys(state.deviceData.data.PR).length) {
      result += Object.keys(state.deviceData.data.PR.PR).length;
    }
    if (Object.keys(state.deviceData.data.PP).length) {
      result += Object.keys(state.deviceData.data.PP.PP).length;
    }
  } else {
    updatedP = updatedDiff(state.deviceData.origin.P, state.deviceData.data.P)
    updatedPR = updatedDiff(state.deviceData.origin.PR, state.deviceData.data.PR)
    updatedPP = updatedDiff(state.deviceData.origin.PP, state.deviceData.data.PP)

    if (Object.keys(updatedP).length) {
      result += Object.keys(updatedP.P).length;
    }
    if (Object.keys(updatedPR).length) {
      result += Object.keys(updatedPR.PR).length;
    }
    if (Object.keys(updatedPP).length) {
      result += Object.keys(updatedPP.PP).length;
    }
  }

  if (result && verbose) {
    console.debug("useCountDataKeys: result", result)
    console.debug("useCountDataKeys: updatedP", updatedP)
    console.debug("useCountDataKeys: updatedPR", updatedPR)
    console.debug("useCountDataKeys: updatedPP", updatedPP)
  }
  return result;
}

export const useCountImportedValues = () => {
  const [ state ] = useContext(AppContext);
  let result = 0;

  for (let key in state.deviceData.data.P.P) {
      if (state.deviceData.data.P.P[key] !== "") {
          result++;
      }
  }
  for (let key in state.deviceData.data.PR.PR) {
      if (state.deviceData.data.PR.PR[key] !== "") {
          result++;
      }
  }
  for (let key in state.deviceData.data.PP.PP) {
      if (state.deviceData.data.PP.PP[key] !== "") {
          result++;
      }
  }

  return result;
}

export const useGetLogo = () => {
  const [ state ] = useContext(AppContext);
  return state.appBrandLogoUrl;
}

export const removeQueryParams = () => {
  const currentUrl = window.location.href;
  const baseUrl = currentUrl.split('?')[0]; // Trennt die URL in Basis und Query-Parameter
  window.history.replaceState({}, '', baseUrl); // Ersetzt die URL im Verlauf
}

export const convertArraysToObjects = (input) => {
  const output = {};
  for (const key in input) {
    if (Array.isArray(input[key])) {
      output[key] = {};
      input[key].forEach((item, index) => {
        if (item !== '') {
          output[key][index.toString().padStart(3, '0')] = item;
        }
      });
    } else {
      output[key] = input[key];
    }
  }
  return output;
};
